/**
 * @generated SignedSource<<381c8c1332410522160ba2c66e4c171c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "CancelOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primeCustomerAction",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelOrderModalMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelOrderModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ac93926832809ecf4e0c206b5a21f0a6",
    "id": null,
    "metadata": {},
    "name": "CancelOrderModalMutation",
    "operationKind": "mutation",
    "text": "mutation CancelOrderModalMutation(\n  $orderId: Int!\n) {\n  CancelOrder(orderId: $orderId) {\n    id\n    status\n    primeCustomerAction\n  }\n}\n"
  }
};
})();

node.hash = "88817d812c5e5fd2dcc99eeae8a8ad5b";

module.exports = node;
